<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.945 116.209">
    <g id="后台管理" transform="translate(0 0)">
      <path id="路径_171" data-name="路径 171"
            d="M143.324,7.747a3.936,3.936,0,0,1,3.874,3.874v92.967a3.936,3.936,0,0,1-3.874,3.874H11.621a3.936,3.936,0,0,1-3.874-3.874V11.621a3.936,3.936,0,0,1,3.874-3.874h131.7m0-7.747H11.621A11.705,11.705,0,0,0,0,11.621v92.967a11.655,11.655,0,0,0,11.621,11.621h131.7a11.655,11.655,0,0,0,11.621-11.621V11.621A11.655,11.655,0,0,0,143.324,0Z"
            class="cls-1"></path>
      <g id="组_296" data-name="组 296" transform="translate(19.368 16.579)">
        <path id="路径_172" data-name="路径 172"
              d="M137.49,39.147H28.719A3.77,3.77,0,0,1,25,35.429v-.31A3.77,3.77,0,0,1,28.719,31.4H137.49a3.77,3.77,0,0,1,3.719,3.719v.31A3.719,3.719,0,0,1,137.49,39.147Z"
              transform="translate(-25 -23.653)" class="cls-1"></path>
        <circle id="runCircle" data-name="椭圆 22" cx="11.621" cy="11.621" r="11.621" class="cls-1"></circle>
      </g>
      <g id="组_297" data-name="组 297" transform="translate(19.368 45.476)">
        <path id="路径_173" data-name="路径 173"
              d="M137.49,76.447H28.719A3.77,3.77,0,0,1,25,72.729v-.31A3.77,3.77,0,0,1,28.719,68.7H137.49a3.77,3.77,0,0,1,3.719,3.719v.31A3.719,3.719,0,0,1,137.49,76.447Z"
              transform="translate(-25 -60.953)" class="cls-1"></path>
        <circle id="椭圆_23" data-name="椭圆 23" cx="11.621" cy="11.621" r="11.621" transform="translate(80.106)"
                class="cls-1"></circle>
      </g>
      <g id="组_298" data-name="组 298" transform="translate(19.523 74.374)">
        <path id="路径_174" data-name="路径 174"
              d="M137.767,113.747H28.919a3.77,3.77,0,0,1-3.719-3.719v-.31A3.77,3.77,0,0,1,28.919,106H137.69a3.77,3.77,0,0,1,3.719,3.719v.31A3.607,3.607,0,0,1,137.767,113.747Z"
              transform="translate(-25.2 -98.253)" class="cls-1"></path>
        <circle id="椭圆_24" data-name="椭圆 24" cx="11.621" cy="11.621" r="11.621" transform="translate(14.642)"
                class="cls-1"></circle>
      </g>
    </g>
  </svg>
</template>

<script>
  import * as d3 from 'd3'

  export default {
    data () {
      return {}
    },
    mounted () {

    }
  }
</script>

<style scoped>
  #runCircle {
    ttransform: translate(10.769px);
    animation: runC 1.5s ease-in-out infinite;
  }

  @keyframes runC {
    from {
      transform: translate(10.769px);
    }
    50%{
      transform: translate(80.106px);
    }
    to{
      transform: translate(10.769px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/svgs/BackgroundManage.vue